import { dateTimeUtils } from '@cocoonspace/shared/utils/date-time-utils'
import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { createZustandSelectors } from '~/lib/create-zustand-selectors'

export type Step = 'intro' | 'day' | 'startTime' | 'payment'

interface VisitBookingState {
	step: Step
	day: string
	startTime: string | null
}

interface VisitBookingActions {
	init: VoidFunction
	setStep: (step: Step) => void
	setDay: (day: string) => void
	setStartTime: (startTime: string) => void
}

const defaultState: Omit<VisitBookingState, 'isDialogOpen'> = {
	step: 'intro',
	day: dateTimeUtils().customFormat('dateTech'),
	startTime: null,
}

const useVisitBookingStoreBase = create<
	VisitBookingState & VisitBookingActions
>()(
	devtools(
		(set) => ({
			...defaultState,
			init: () => set(defaultState),
			setStep: (step) => set({ step }),
			setDay: (day) => set({ day }),
			setStartTime: (startTime) => set({ startTime }),
		}),
		{ name: 'visit-booking' },
	),
)

export const useBookingVisitStore = createZustandSelectors(
	useVisitBookingStoreBase,
)
